import {
  CollectionEntryOptions,
  createCollectionEntryExtension,
} from '@spotify/plugin-confidence-collections-react';

import { projectsPlugin } from '../plugin';
import { projectRouteRef } from '../routes';

export const ProjectCollectionEntryExtension = projectsPlugin.provide(
  createCollectionEntryExtension({
    id: 'project',
    resourceType: 'Project',
    routeRef: projectRouteRef,
    predicate: ({ resource }: CollectionEntryOptions) =>
      '__typename' in resource &&
      resource.__typename === 'CollaborationV1Project',
    render: () => null,
  }),
);
